import { Link } from 'react-router-dom';
import './DogCard.css';

const STATUS_LABELS = {
  available:     { label: 'Available',     cls: 'badge-available' },
  pending:       { label: 'Pending',       cls: 'badge-pending'   },
  adopted:       { label: 'Adopted',       cls: 'badge-adopted'   },
  not_available: { label: 'Not Available', cls: 'badge-pending'   },
};

// Returns emoji based on 1/0/null value
function traitIcon(val) {
  if (val === 1)  return '✅';
  if (val === 0)  return '❌';
  return '❓';
}

const TRAITS = [
  { key: 'good_with_dogs', label: 'Good with dogs' },
  { key: 'good_with_cats', label: 'Good with cats' },
  { key: 'good_with_kids', label: 'Good with kids' },
  { key: 'house_trained',  label: 'House trained'  },
];

export default function DogCard({ dog }) {
  const status = STATUS_LABELS[dog.status] || STATUS_LABELS.available;

  const ageText = () => {
    const yrs = dog.age_years;
    const mos = dog.age_months;
    if (!yrs && !mos) return null;
    if (yrs && mos)   return `${yrs}y ${mos}mo`;
    if (yrs)          return `${yrs} year${yrs > 1 ? 's' : ''}`;
    return `${mos} month${mos > 1 ? 's' : ''}`;
  };

  return (
    <Link to={`/dogs/${dog.id}`} className="dog-card card">
      <div className="dog-card__photo">
        {dog.primary_photo ? (
          <img src={`https://runarounddogtown.com/rescue-api${dog.primary_photo}`} alt={dog.name} />
        ) : (
          <div className="dog-card__no-photo">🐾</div>
        )}
        <span className={`badge ${status.cls} dog-card__badge`}>{status.label}</span>
        {dog.featured && <span className="dog-card__featured">⭐ Featured</span>}
      </div>
      <div className="dog-card__body">
        <h3 className="dog-card__name">{dog.name}</h3>
        <div className="dog-card__meta">
          {dog.breed && <span>{dog.breed}</span>}
          {ageText() && <span>{ageText()}</span>}
          {dog.gender && dog.gender !== 'unknown' && (
            <span>{dog.gender.charAt(0).toUpperCase() + dog.gender.slice(1)}</span>
          )}
          {dog.size && <span>{dog.size.replace('_', ' ')}</span>}
        </div>
        {dog.description && (
          <p className="dog-card__desc">
            {dog.description.length > 100
              ? dog.description.slice(0, 100) + '…'
              : dog.description}
          </p>
        )}
        <div className="dog-card__traits">
          {TRAITS.map(t => (
            <div className="dog-card__trait-row" key={t.key}>
              <span className="dog-card__trait-icon">{traitIcon(dog[t.key])}</span>
              <span className="dog-card__trait-label">{t.label}</span>
            </div>
          ))}
          {dog.special_needs === 1 && (
            <div className="dog-card__trait-row dog-card__trait-row--special">
              <span className="dog-card__trait-icon">💛</span>
              <span className="dog-card__trait-label">Special needs</span>
            </div>
          )}
        </div>
      </div>
    </Link>
  );
}
